const tinymce = require("tinymce/tinymce");
require("tinymce/models/dom/model");
require("tinymce/icons/default/icons");
require("tinymce/themes/silver");
require("tinymce/plugins/code/plugin");
require("tinymce/plugins/link/plugin");
require("tinymce/plugins/lists/plugin");
require("tinymce-i18n/langs/de");
const { defaultTinyMceConfig } = require("../common/tinymce-config");

function Mailtext(contentCss) {
	tinymce.init({
		...defaultTinyMceConfig,
		selector: "#html",
		height: 600,
		content_css: contentCss
	});
}

module.exports = Mailtext;
